<template>

    <article v-if="item" id="Reminder" :class="[{ 'active': active }, createSceneClass(item.scene)]">

        <button class="close" @click="snooze()"> <img src="@/assets/img/ui/close-white.svg"></button>

        <header>
            <!-- <img src="@/assets/img/ui/icon-alert.svg"> -->
            <span>Hey! It's time to enter</span>
            <div class="scene-label">{{ item.scene }}</div>
        </header>

        <div class="mid">
            <span v-if="showEnterButton" v-html="item.reminderText"></span>
            <span v-else>The next livestream will begin in:</span>
            <!-- <h2>{{ Math.floor(reminderTime / 60) }}:{{ reminderTime % 60 }}</h2> -->
            <h2>{{ timeLeft }}</h2>
            <button @click="enterActivity()" v-if="showEnterButton">ENTER</button>
        </div>


        <!-- taleboble trekant -->
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="31" viewBox="0 0 36 31">
            <path id="Polygon_2" data-name="Polygon 2"
                d="M16.27,2.979a2,2,0,0,1,3.459,0L34.256,28a2,2,0,0,1-1.73,3H3.474a2,2,0,0,1-1.73-3Z"
                transform="translate(36 31) rotate(180)" />
        </svg>
    </article>






</template>
<script>
const moment = require('moment');

export default {
    props: ["active", "item"],
    emits: ['snooze'],
    data() {
        return {
            timeUpdater: null,
            timeLeft: null,
            showEnterButton: true
        }
    },

    watch: {
       
        active(newValue, oldValue) {

            // when active start countdown
            if (newValue) {

                // Set up the interval to check time every second
                this.timeUpdater = setInterval(this.checkTime, 1000);
                this.checkTime();

                // hide enter button if already on the promted scene
                if (this.onPromtedScene()) {
                    this.showEnterButton = false;
                } else {
                    this.showEnterButton = true;
                }

            } else {
                clearInterval(this.timeUpdater);
            }
        },

        // double snooze if scene changes to promted scene
        $route() {
           
            if (this.active && this.onPromtedScene()) {

                // double snooze to avoid showing same reminder again
                this.snooze();
                this.snooze();
            }

        }

    },



    mounted() {

    },

    methods: {

        createSceneClass(str) {
            return 'scene-' + str.split(" ").join("-").toLowerCase();
        },
        checkTime() {
            if (this.item) {
                let now = moment();
                var secondsLeft = moment(this.item.startTime).diff(now, 'seconds');
                let duration = moment.duration(secondsLeft, 'seconds');
                this.timeLeft = moment.utc(duration.asMilliseconds()).format('mm:ss');

                if (secondsLeft == 0) {
                    this.$emit('snooze');
                }
            }
        },
        snooze() {
            this.$emit('snooze');
        },
        enterActivity() {
            // var route = app.api.PageManager.getRouteFromIDs(this.item.sceneId, this.item.contentId);
            // app.api.PageManager.navigateToRoute(route);
            this.item.useReminder = false;

            var route = app.api.PageManager.getRouteFromIDs(this.item.sceneId);
            app.api.PageManager.navigateToRoute(route);

            if (this.item.contentId) {
                setTimeout(() => {
                    app.api.PageManager.openContentComponentFromID(this.item.contentId)
                }, 2000);
            }

            // this.$emit('snooze');
            // let route watch snooze the reminder

        },
        onPromtedScene(){
            let currentRoute = app.api.PageManager.getPage(this.$route.path);
            let currentSceneID = (currentRoute) ? currentRoute.data.id : 0;

            return (this.item.sceneId == currentSceneID)
        }
    },

    computed: {


    }
}
</script>
<style lang="scss" scoped>
$padding: 30px;

#Reminder {
    position: absolute;
    text-align: left;
    min-height: 190px;
    width: 320px;
    bottom: 150px;
    left: 70px;
    padding: $padding;
    z-index: 1;
    border-radius: 15px;
    transform: translateY(440px);
    transition: transform 0.5s var(--expo-easeinout);

    &.active {
        transform: translateY(0);
    }

    button.close {
        position: absolute;
        right: 6px;
        top: 6px;

        img {
            width: 20px;
        }
    }

    header {

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;

        .scene-label {
            background: #fff3;
            height: 20px;
            width: 87px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 20px;
            font-size: 10px;
        }
    }

    .mid {

        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 0px;


        span {
            display: block;
            line-height: 1.3em;
            margin-top: 1em;
            text-align: center;

        }

        h2 {
            font-family: 'Arla Strong';
            font-size: 40px;
            margin: 0.4em;
        }

        button {
            width: 112px;
            height: 40px;
            border: 3px solid #fff;
            border-radius: 20px;
            display: flex;
            justify-content: center;
            align-items: center;

            &:hover {
                background-color: #fff;
            }
        }
    }

    svg {
        position: absolute;
        bottom: -28px;
        left: 50px;
    }

}


.scene-parking-lot {
    background-color: var(--mid-green);
    color: #fff;

    svg>path {
        fill: var(--mid-green);
    }

    .scene-label {
        color: #fff;
    }

    button:hover {
        color: var(--dark-green);
    }
}

.scene-milk-reception {
    background-color: var(--baby-blue);
    color: var(--petrol);
    color: #fff;

    svg>path {
        fill: var(--baby-blue);
    }

    .scene-label {
        color:  var(--petrol);
    }

    button:hover {
        color: var(--baby-blue);
    }
}

.scene-production {
    background-color: var(--yellow);
    color: var(--yellow-brown);
    color: #fff;

    svg>path {
        fill: var(--yellow);
    }

    .scene-label {
        color: var(--yellow-brown);
    }

    button:hover {
        color: var(--yellow);
    }
}

.scene-warehouse {
    background-color: var(--rusty-red);
    color: #fff;

    svg>path {
        fill: var(--rusty-red);
    }

    button:hover {
        color: var(--rusty-red);
    }
}

.scene- {
    background-color: #fff;

    svg>path {
        fill: #fff;
    }
}
</style>